// MFN-Skripter
//*************
export default () => {
    var smallgraph = document.getElementsByClassName("smallgraph");
    var graphtable = document.getElementsByClassName("graphtable");
    var ownerlist = document.getElementsByClassName("ownerlist");
    var stockcalculator = document.getElementsByClassName("stockcalculator");
    var subscribe = document.getElementById("mfn_subscribe");

    var graph = {};
    var table = {};
    var calc = {};
    var sub = {};
    var widgets = [];

    var lang = nobox.currentLang;

    if(smallgraph.length > 0) {
        graph = {
            query: ".smallgraph",
            widget: "stock-chart",
            locale: "en",
            token: "db6a63d6-d071-45ab-831b-d86fbc04ceac",
            c: "1022cb6f-bc0a-4ca9-846c-a40037b72d34",
            locale: lang,
            demo: false // Only true when you using demo data
        }
        widgets.push(graph);
    }

    if(graphtable.length > 0) {
        table = {
            query: ".graphtable",
            widget: "stock-table",
            locale: "en",
            token: "fbc9202e-1b45-4213-85d7-45b99e6e3756",
            c: "1022cb6f-bc0a-4ca9-846c-a40037b72d34",
            locale: lang,
            demo: false // Only true when you using demo data
        }
        widgets.push(table);
    }

    if(ownerlist.length > 0) {
        table = {
            query: ".ownerlist",
            widget: "owner-list",
            locale: "en",
            token: "6bef5591-dc3e-4b62-8c9a-0371700810ee",
            c: "1022cb6f-bc0a-4ca9-846c-a40037b72d34",
            locale: lang,
            demo: false // Only true when you using demo data
        }
        widgets.push(table);
    }

    if(stockcalculator.length > 0) {
        calc = {
            query: ".stockcalculator",
            widget: "stock-calculator",
            locale: "en",
            token: "e4009465-0dbb-42ea-874a-262aadb4bf73",
            c: "1022cb6f-bc0a-4ca9-846c-a40037b72d34",
            locale: lang,
            demo: false // Only true when you using demo data
        }
        widgets.push(calc);
    }

    if(subscribe) {
        sub = {
            query: "#mfn_subscribe",
            widget: "subscribe",
            locale: "en",
            token: "3bb784b1-0a6f-4258-8ed1-cfa70ba7b86f",
            c: "1022cb6f-bc0a-4ca9-846c-a40037b72d34",
            locale: lang,
        }
        widgets.push(sub);
    }

    (function(wid) {
        window._MF = window._MF || {
            data: [wid],
            url:"https://widget.datablocks.se/api/rose",
            ready: !!0,
            render: function() {
                window._MF.ready = !0;
            }};
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = window._MF.url + "/assets/js/loader-v3.js";
        document.getElementsByTagName("body")[0].appendChild(b);
    })(widgets);
};
